import { useCallback, useMemo, useState } from "react"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import { ApplicationDispatchContext, ApplicationStateContext, initialState } from "./ApplicationContext.context"

export const ApplicationContextProvider = (props) => {

    const { children } = props

    const [state, setState] = useState(initialState)

    const setNavigationOrigin = useCallback((newOrigin) => {
        setState(prevState => ({
            ...prevState,
            navigationOrigin: newOrigin,
        }))
    }, [])

    const setCurrentBottomSheetHeight = useCallback((newState) => {
        setState(prevState => ({
            ...prevState,
            currentBottomSheetHeight: newState,
        }))
    }, [])

    const dispatchValue = useMemo(() => {
        return ({
            setCurrentBottomSheetHeight,
            setNavigationOrigin,
        })
    }, [setCurrentBottomSheetHeight, setNavigationOrigin])

    return (
        <ApplicationStateContext.Provider value={state}>
            <ApplicationDispatchContext.Provider value={dispatchValue}>
                {children}
            </ApplicationDispatchContext.Provider>
        </ApplicationStateContext.Provider>
    )
}

ApplicationContextProvider.propTypes = {
    children: PropTypes.node,
}
